import React from 'react';
import {useTranslation} from "../../hooks/useTranslation";

export function LoadingIcon() {

    const translate = useTranslation();

    return (
        <div className={'loading--icon'}>
            <span>{translate('loading_text')}</span>
        </div>
    );
}
